import React from "react";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { BeatLoader } from "react-spinners";
import { Card, Container, Col, Row } from "react-bootstrap";
import { GoogleAuthButton } from "./GoogleAuthButton";
import {RegisterPage} from '../general/RegisterPage';
import { CampoPassword, history } from "../../_helpers";
import tiendaService from "../../_services/cart/tienda.service";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      showPassword: false,
      token: undefined,
    };

    this.props.logout();
  }

  irARegistrarse = () => {
    history.push('/register');
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitted: true });
    const { username, password } = this.state;

    if (username && password) {
      this.props.login(username, password, undefined, this.props.onSuccess);
    }
  };

  errorGtoken(error) {
    console.log("ERROR GTOKEN:", error);
  }

  responseGoogleFail = (response) => {
    console.log("FALLO DE GOOGLE:", response);
  };

   togglePasswordVisibility = () => {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword
    }));
  };


  render() {
    const { loggingIn } = this.props;
    const { username, password, submitted, showPassword  } = this.state;

    return (
      <div className="container__dap">
      <div className="login">
        <div className="login__container">
        <div className="login__header">
          {tiendaService.esTienda() ? (
            <>
              <h2 className="">Ingresá a <span> {tiendaService.actual().nombre}</span></h2>
              <span className="small">
              Con tu cuenta de esta tienda comprás, consultás y seguís tus pedidos.
              </span>
            </>
          ) : (
            <>
              <h2 className="">Ingresá a la comunidad <span> DEAUTOPARTES</span></h2>
              <span className="small">
              Es un sitio donde vendedores y compradores de
              autopartes pueden encontrar lo que buscan
              </span>
            </>
          )}
        </div>
        <div className="login__body">
          <form name="form" onSubmit={this.handleSubmit}>
          <div
            className={
            "form-group" + (submitted && !username ? " has-error" : "")
            }
          >
            <label htmlFor="username">Email</label>
            <div className="input-group">
            <input
              type="text"
              className="form-control"
              name="username"
              value={username}
              onChange={this.handleChange}
            />
            </div>
            {submitted && !username && (
            <div className="help-block text-danger">
              Usuario Inválido
            </div>
            )}
          </div>
          <div className={"form-group" + (submitted && !password ? " has-error" : "")}>
            <label htmlFor="password">Contraseña</label>
            <CampoPassword
              mostrar={showPassword}
              onToggle={this.togglePasswordVisibility}
            >
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                className="form-control"
                name="password"
                value={password}
                onChange={this.handleChange}
              />
            </CampoPassword>
            {submitted && !password && (
            <div className="help-block text-danger">
              <i className="fas fa-exclamation-circle"></i> Contraseña
              Inválida
            </div>
            )}
          </div>
          <div className="login-btn">
            <button className="button" data-type="primary">
            Acceder a mi cuenta
            {loggingIn && (
              <div className="sweet-loading">
              <BeatLoader
                size={10}
                color={"#FFFFFF"}
                loading={this.state.loading}
              />
              </div>
            )}
            </button>
          </div>
          </form>
        </div>
        {/* Google no acepta subdominios comodin: en las tiendas propias se entra con mail y clave. */}
        {!tiendaService.esTienda() && (
        <div className="login__socialButtons">
          <span className="other__buttons">O</span>

          <GoogleAuthButton login={this.props.login} onSuccess={this.props.onSuccess} />
        </div>
        )}
        <div className="register__button">
          <span>Si no tenés usuario podés</span>
          <button
          className="button"
          data-type="complementary"
          onClick={this.irARegistrarse}
          >
          Crear una cuenta
          </button>
        </div>
        </div>
      </div>
      </div>
    );
  }
}

function mapState(state) {
  const { loggingIn } = state.authentication;
  return { loggingIn };
}

const actionCreators = {
  login: userActions.login,
  logout: userActions.logout,
};

const connectedLoginPage = connect(mapState, actionCreators)(LoginPage);
export { connectedLoginPage as LoginPage };
